export const finnishTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Etusivu',
  'nav.shop': 'Tuotteet',
  'nav.about': 'Meista',
  'nav.contact': 'Yhteystiedot',
  'nav.blog': 'Blogi',
  'nav.trackOrder': 'Seuraa tilausta',

  // Hero
  'hero.badge.pdrn': 'PDRN-teknologia',
  'hero.badge.glassSkin': 'Glass Skin -efekti',
  'hero.badge.korean': 'Korealainen innovaatio',
  'hero.title': 'PDRN-ihonhoito - korealainen lohi-DNA',
  'hero.subtitle': 'Muuta ihosi kliinisesti todistetuilla PDRN-seerumilla, kangasnaamioilla ja kapselivoiteella. Saavuta Glass Skin -efekti premium-PDRN-ihonhoitotuotteilla, jotka perustuvat lohen DNA:han.',
  'hero.cta': 'Tutustu mallistoon',
  'hero.ctaSurvey': 'Ilmainen ihoanalyysi',
  'hero.socialProof': 'Yli 10 000 ihonhoitoharrastajan suosikki',
  'survey.bubbleTooltip': 'Henkilokohtainen rutiini + 10% alennus',

  // Products
  'products.title': 'Mallistomme',
  'products.subtitle': 'Premium-korealainen ihonhoito PDRN-teknologialla',
  'products.addToCart': 'Lisaa ostoskoriin',
  'products.buyNow': 'Osta nyt',
  'products.soldOut': 'Loppuunmyyty',
  'products.save': 'Tarjous',
  'products.viewDetails': 'Lisatiedot',
  'products.noProducts': 'Tuotteita ei ole talla hetkella saatavilla',
  'products.selectSize': 'Valitse koko',
  'products.quantity': 'Maara',
  'products.inStock': 'Varastossa',
  'products.outOfStock': 'Loppuunmyyty',

  // Upsell
  'upsell.title': 'Taydenna rutiinisi',
  'upsell.savings': 'Saasta taydellisella setilla',
  'upsell.cta': 'Paivita taydelliseen settiin',
  'upsell.includes': 'Taysi ihonhoitorutiini yhdessa paketissa',
  'upsell.badge': 'Taydenna rutiinisi',
  'upsell.saveBadge': 'Saastat {amount}!',
  'upsell.whyBundle': 'Miksi valita taysi setti?',
  'upsell.whyBundleDesc': 'Jokainen vaihe rakentuu edellisen paaalle maksimaalisten tulosten saavuttamiseksi',
  'upsell.includesSerum': 'Hehkuseerumi',
  'upsell.includesCream': 'Alyas kapselivoide',
  'upsell.includesMasks': '10 naamion pakkaus',
  'upsell.separatelyPrice': 'Erikseen: {amount}',
  'upsell.serumTooltip': 'Kevyt PDRN-seerumi, joka edistaa kollageenin tuotantoa, silottaa ryppyja ja antaa valittoman Glass Skin -hehkun.',
  'upsell.creamTooltip': 'Innovatiivinen kapselikaava PDRN:lla, 5% niasiiniamidilla ja hydrolysoidulla kollageenilla syvakosteuttamiseen ja kiinteytykseen.',
  'upsell.masksTooltip': '10 kangasnaamiota, jotka on kyllastetty konsentroidulla PDRN-seerumilla intensiiviseen hoitoon, joka antaa valittoman Glass Skin -efektin.',

  // Cart
  'cart.title': 'Ostoskori',
  'cart.empty': 'Ostoskorisi on tyhja',
  'cart.itemCount': '{count} tuotetta korissa',
  'cart.total': 'Yhteensa',
  'cart.checkout': 'Kassalle',
  'cart.continueShopping': 'Jatka ostoksia',
  'cart.addedToCart': 'Lisatty ostoskoriin!',
  'cart.couponPlaceholder': 'Alennuskoodi',
  'cart.applyCoupon': 'Kayta',
  'cart.couponApplied': 'Alennus kaytetty!',
  'cart.couponError': 'Virheellinen koodi',
  'cart.removeCoupon': 'Poista',
  'cart.freeShippingUnlocked': 'Sait ilmaisen toimituksen!',
  'cart.freeShippingRemaining': 'Lisaa {amount} ilmaiseen toimitukseen',
  'cart.freeShippingThreshold': 'Ilmainen toimitus tilauksiin yli {amount}',
  'cart.completeRoutine': 'Taydenna rutiinisi',
  'cart.bundleSave': 'Saasta {percent}%',
  'cart.quickAdd': 'Lisaa',

  'promo.b2g1': '🎁 Lisää 3 tuotetta ostoskoriin — 1 on ILMAINEN!',
  'promo.b2g1Cart': '🎁 2+1-tarjous käytössä! Joka 3 tuotteesta 1 on ILMAINEN!',
  'promo.b2g1CartHint': 'Lisää vielä {count} saadaksesi ILMAISEN tuotteen! (3 tuotetta vaaditaan)',
  'promo.b2g1Saving': 'Säästät {amount} — halvin tuote on ILMAINEN!',
  'promo.freeItem': '🎁 ILMAINEN kampanjassa',

  // About
  'about.title': 'Meista',
  'about.subtitle': 'Tiede korealaisen kauneuden takana',
  'about.pdrnTitle': 'PDRN-ihonhoidon tiede',
  'about.pdrnDescription': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - vallankumouksellinen ainesosa korealaisessa ihonhoidossa. PDRN-tuotteemme edistavat solujen uusiutumista taydellisen Glass Skin -efektin saavuttamiseksi.',
  'about.glassSkinDesc': 'Saavuta haluttu korealainen Glass Skin -efekti valittomalla hehkulla.',
  'about.hydrationDesc': 'Syvakosteutus, joka kestaa koko paivan, kliinisesti todistetulla kosteuden sailyttamisella.',
  'about.antiAgingDesc': 'Lisaa luonnollisesti kollageenin tuotantoa kiinteampaa ja nuorekkaampaa ihoa varten.',

  // Footer
  'footer.copyright': '\u00a9 2026 PDRN SKIN. Kaikki oikeudet pidatetaan.',
  'footer.freeShipping': 'Ilmainen toimitus yli {amount} (Suomi)',
  'footer.securePayment': 'Turvallinen maksu',
  'footer.support': 'Tuki 24/7',
  'footer.description': 'Premium-korealainen ihonhoito vallankumouksellisella PDRN-teknologialla. Koe Glass Skin -efekti tieteellisilla tuotteillamme.',
  'footer.sheetMasks': 'Kangasnaamiot',
  'footer.serum': 'Seerumi',
  'footer.cream': 'Voide',
  'footer.bundle': 'Taysi setti',
  'footer.faq': 'Usein kysytyt kysymykset',
  'footer.shippingReturns': 'Toimitus ja palautukset',
  'footer.privacyPolicy': 'Tietosuojakaytanto',
  'footer.termsOfService': 'Kayttoehdot',
  'footer.returnPolicy': 'Palautuskaytanto',
  'footer.contactSupport': 'Olemme täällä sinua varten — kysymykset, tilaustiedot, ongelmat tai ostoapu. Tavoita asiakaspalvelumme osoitteessa',

  // Common
  'common.verified': 'Vahvistettu',
  'common.before': 'Ennen',
  'common.after': 'Jalkeen',
  'common.loading': 'Ladataan...',
  'common.error': 'Tapahtui virhe',
  'common.noPhotoShared': 'Asiakas ei liittanyt valokuvaa',

  // Media
  'media.videoPlaceholder': 'Videon paikkamerkki',
  'media.gifPlaceholder': 'GIF-paikkamerkki',
  'media.imagePlaceholder': 'Kuvan paikkamerkki',

  // Features
  'feature.hydration': '+100% kosteutus',
  'feature.glassSkin': 'Glass Skin -efekti',
  'feature.antiAging': 'Anti-aging',
  'feature.collagen': 'Kollageenibuusti',
  'feature.brightening': 'Kirkastus',

  // Product
  'product.howToUse': 'Kayttoohjeet',
  'product.ingredients': 'Paaaainesosat',
  'product.reviews': 'Asiakasarvostelut',
  'product.results': 'Todelliset tulokset',
  'product.realResults': 'Todelliset tulokset',
  'product.beforeAfter': 'Ennen ja jalkeen',
  'product.faqTitle': 'Kysymyksia ja vastauksia',
  'product.mediaGallery': 'Mediagalleria',
  'product.freeShipping': 'Ilmainen toimitus alkaen {amount}',
  'product.secureCheckout': 'Turvallinen maksu',
  'product.returns': 'Palautus 7 paivan sisalla',
  'product.koreanFormula': 'Korealainen kaava',
  'product.premiumIngredients': 'Premium-ainesosat',
  'product.backHome': 'Takaisin etusivulle',
  'product.notFound': 'Tuotetta ei loydy',
  'product.bestValue': 'Paras arvo',
  'product.bestseller': 'Myyntivaltti',
  'product.reviewCount': '({count} arvostelua)',
  'product.crueltyFree': 'Ei elainkokeita',
  'product.youMayAlsoLike': 'Saatat pitaa myos naista',
  'product.completeRoutine': 'Taydenna ihonhoitorutiinisi',
  'product.moneyBack': 'Rahat takaisin 7 paivan sisalla',
  'product.dermatologistTested': 'Dermatologisesti testattu',
  'product.payWith': 'Turvallinen maksu kautta',
  'product.specsTitle': 'Tuotetiedot',
  'product.specsVolume': 'Koko',
  'product.specsSkinType': 'Ihotyyppi',
  'product.specsTested': 'Testaukset',
  'product.specsClinicallyTested': 'Kliinisesti testattu',
  'product.specsShelfLife': 'Sailyvyys',
  'product.specsFreeOf': 'Ei parabeeneja, sulfaatteja eika ftalaatteja',
  'product.satisfactionGuarantee': '100% tyytyv\u00e4isyystakuu',
  'product.satisfactionDesc': 'Kokeile riskittomasti 7 paivan rahat takaisin -takuullamme',

  // Before/After
  'beforeAfter.customer1': 'Aino',
  'beforeAfter.customer2': 'Emilia',
  'beforeAfter.customer3': 'Saara',
  'beforeAfter.weeks3': '3 viikon kayton jalkeen',
  'beforeAfter.weeks8': '8 viikon kayton jalkeen',
  'beforeAfter.weeks12': '12 viikon kayton jalkeen',

  // Mobile Cart
  'mobileCart.findRoutine': 'Loyda rutiinisi',

  // Survey
  'survey.buttonText': 'Loyda rutiinisi',
  'survey.title': 'Ihoanalyysi',
  'survey.subtitle': 'Vastaa muutamaan lyhyeen kysymykseen ja loydan sinulle taydellisen rutiinin',
  'survey.question': 'Kysymys',
  'survey.back': 'Takaisin',
  'survey.next': 'Seuraava',
  'survey.getResults': 'Tulokset',
  'survey.resultsTitle': 'Sinulle valitsemani rutiini',
  'survey.resultsSubtitle': 'Vastaustesi perusteella tassa on suositukseni',
  'survey.yourProfile': 'Ihoprofiilisi',
  'survey.recommended': 'Suositeltu sinulle',
  'survey.bundleNote': 'Parhaat tulokset saat taydellisella setilla',
  'survey.howToUse': 'Sinulle valitsemani rutiini',
  'survey.morning': 'Aamu',
  'survey.evening': 'Ilta',
  'survey.expectedResults': 'Odotetut tulokset',
  'survey.week': 'Viikko',
  'survey.weeks': 'Viikkoa',
  'survey.personalTips': 'Vinkkini sinulle',
  'survey.retake': 'Taytta uudelleen',
  'survey.shopNow': 'Osta nyt',
  'survey.errorTooMany': 'Liikaa pyyntoja. Yrita myohemmin uudelleen.',
  'survey.errorGeneric': 'Jokin meni pieleen. Yrita uudelleen.',
  'survey.yourPersonalizedRoutine': 'Sinulle valitsemani rutiini',
  'survey.treatmentPlan': 'Suositeltu hoitojakso',
  'survey.addRoutineToCart': 'Lisaa rutiini ostoskoriin',
  'survey.satisfactionGuarantee': '100% tyytyv\u00e4isyystakuu',
  'survey.maybeLater': 'Ehka myohemmin',
  'survey.continueSurvey': 'Jatka kyselya',
  'survey.addedToCart': 'Tuotteet lisatty ostoskoriin!',
  'survey.personalizedRoutine': 'Henkilokohtainen rutiinisi on valmis',
  'survey.errorAddingToCart': 'Virhe lisattaessa ostoskoriin',
  'survey.exclusiveDiscount': '10% eksklusiivinen alennus sinulle!',
  'survey.couponCopied': 'Kuponkikoodi kopioitu!',
  'survey.useAtCheckout': 'Kayta koodia SURVEY10 kassalla saadaksesi 10% alennuksen',
  'survey.bestDeal': 'Paras loytamani tarjous sinulle!',
  'survey.separatePrice': 'Erikseen',
  'survey.yourPrice': 'Sinun hintasi',
  'survey.youSave': 'Saastat',
  'survey.upgradeOption': 'Haluatko viela parempia tuloksia?',
  'survey.upgradeToBundle': 'Paivita taydelliseen rutiiniin',
  'survey.upgradeSave': 'Saasta {amount} taydellisella setilla',
  'survey.addSingleToCart': 'Lisaa ostoskoriin',

  // Survey loading messages
  'survey.loading.analyzing': 'Analysoin ihoprofiiliasi...',
  'survey.loading.planning': 'Suunnittelen henkilokohtaista hoitoa...',
  'survey.loading.matching': 'Etsin taydelliset tuotteet sinulle...',
  'survey.loading.finalizing': 'Melkein valmista...',

  // Survey questions
  'survey.q1.question': 'Mika on ihotyyppisi?',
  'survey.q1.dry': 'Kuiva - ihoni tuntuu usein kirealta',
  'survey.q1.oily': 'Rasvainen - kiiltava, erityisesti otsalla ja nenassa',
  'survey.q1.combination': 'Sekaiho - rasvainen otsa ja nena, kuivat posket',
  'survey.q1.normal': 'Normaali - tasapainoinen, ei merkittavia ongelmia',
  'survey.q2.question': 'Mika ihossasi hairitsee sinua eniten?',
  'survey.q2.aging': 'Ryppyja ja ilmeviivoja',
  'survey.q2.acne': 'Aknea ja nappyloita',
  'survey.q2.dullness': 'Samea iho ja epahtasainen savy',
  'survey.q2.hyperpigmentation': 'Tummat lamput ja hyperpigmentaatio',
  'survey.q3.question': 'Kuinka herkkaa ihosi on?',
  'survey.q3.very': 'Erittain herkka - reagoi useimpiin tuotteisiin',
  'survey.q3.somewhat': 'Melko herkka - satunnaisia reaktioita',
  'survey.q3.not': 'Ei herkka - sietaa useimpia tuotteita',
  'survey.q4.question': 'Kuinka hyvin ihosi on kostutettu?',
  'survey.q4.veryDry': 'Erittain kuiva - tarvitsee jatkuvaa kosteuttamista',
  'survey.q4.somewhatDry': 'Hieman kuiva - tarvitsee saannollista kosteuttamista',
  'survey.q4.balanced': 'Tasapainoinen - ei kuiva eika rasvainen',
  'survey.q4.wellHydrated': 'Hyvin kostutettu - kiintea ja terve',
  'survey.q5.question': 'Mika on ikahaarukkasi?',
  'survey.q5.under25': 'Alle 25',
  'survey.q5.25to35': '25-35',
  'survey.q5.35to45': '35-45',
  'survey.q5.over45': 'Yli 45',
  'survey.q6.question': 'Miten kuvailisit nykyista ihonhoitorutiiniasi?',
  'survey.q6.minimal': 'Minimaalinen - vain puhdistus ja kosteutus',
  'survey.q6.basic': 'Perus - puhdistus, kasvovesi, kosteutus',
  'survey.q6.moderate': 'Kohtalainen - sisaltaa seerumeja ja hoitoja',
  'survey.q6.extensive': 'Laaja - taysi korealainen ihonhoitorutiini',
  'survey.q7.question': 'Miten kuvailisit ihosi rakennetta?',
  'survey.q7.smooth': 'Silea ja tasainen',
  'survey.q7.rough': 'Karkea ja teksturoitu',
  'survey.q7.uneven': 'Epatisainen muutamilla kohoumilla',
  'survey.q7.bumpy': 'Epatasainen nakyvilla huokosilla',
  'survey.q8.question': 'Mika on paatavoitteesi ihonhoidossa?',
  'survey.q8.glow': 'Saavuttaa korealainen hehkuefekti',
  'survey.q8.antiAging': 'Vahentaa ikaantymisen merkkeja',
  'survey.q8.hydration': 'Syvakosteutus',
  'survey.q8.all': 'Kaikki edella mainitut',

  // Trust Strip
  'trust.clinicallyTested': 'Kliinisesti testattu',
  'trust.happyCustomers': 'Yli 10 000 tyytyvaista asiakasta',
  'trust.labFormula': 'Korealainen laboratoriokaava',
  'trust.moneyBack': 'Rahat takaisin 7 paivan sisalla',

  // Science
  'science.title': 'PDRN lohen DNA:sta - tieteellisesti todistettu',
  'science.subtitle': 'PDRN on kliinisesti todistettu vertaisarvioitujen tutkimusten avulla',
  'science.citation1': '"PDRN edistaa haavojen paranemista ja kudosten uusiutumista aktivoimalla adenosiini A2A -reseptorin."',
  'science.source1': '- Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '"Lohesta peraoisin oleva PDRN parantaa merkittavasti kosteutta, joustavuutta ja vahentaa ryppyjen syvyytta kliinisissa kokeissa."',
  'science.source2': '- International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'Tiede sisalla',
  'scienceInside.subtitle': 'Miksi tama kaava toimii - kaksi tehokasta moottoria yhdessa seerumissa',
  'scienceInside.peptides.title': 'Peptidit - insinoorit',
  'scienceInside.peptides.subtitle': '"Alykkaat viestinviejat, ei taikavoide"',
  'scienceInside.peptides.point1': 'Lyhyet aminohappoketjut, jotka viestivat ihollesi kayttaytymaan kuin nuori, uudistunut iho',
  'scienceInside.peptides.point2': 'Tukevat kiinteampaa ulkonakoa ja vahemman nakyvat ryppyja ajan myota',
  'scienceInside.peptides.point3': 'Vahvistavat ihon suojamuuria - iho tuntuu vahemman "hauraalta" ja vahemman reaktiiviselta',
  'scienceInside.peptides.point4': 'Alyas vaikutus, joka vahvistuu johdonmukaisella kaytolla, ei yhden paivan ihme',
  'scienceInside.pdrn.title': 'PDRN - uudistaja',
  'scienceInside.pdrn.subtitle': 'Johtava uudistava ainesosa K-Beauty-maailmassa',
  'scienceInside.pdrn.point1': 'DNA-fragmentteja, jotka puhuvat uudistumisen ja korjaamisen kielta',
  'scienceInside.pdrn.point2': 'Tukee ihon laatua ja edistaa tervetta, tiivista ulkonakoa',
  'scienceInside.pdrn.point3': 'Rauhoittaa stressaantunutta tai reaktiivista ihoa - vahemman punoitusta, enemman tasapainoa',
  'scienceInside.pdrn.point4': 'Seerumissa: johdonmukainen ja alyas parannus - ei dramaattinen yhdessa yossa',
  'scienceInside.combo.title': 'Kaksi moottoria, yksi seerumi',
  'scienceInside.combo.subtitle': 'Valitdn hehku + kumulatiivinen anti-aging',
  'scienceInside.combo.point1': 'Moottori 1: "Nakee heti" - kosteutus, valon hajottaminen, sileampi tekstuuri',
  'scienceInside.combo.point2': 'Moottori 2: "Nakee ajan myota" - kiinteytys, joustavuus, korjaus',
  'scienceInside.combo.point3': 'Valiton "vau"-efekti motivoi sinua jatkamaan - peptidit ja PDRN tekevat lopun',
  'scienceInside.combo.point4': 'Tulos: iho, joka nayttaa tiivislta, rauhalliselta ja kiillotetulta',
  'scienceInside.tagline': 'Peptidit rakentavat ja vahvistavat. PDRN korjaa ja rauhoittaa. Yhdessa ne antavat ihollesi seka valittoman hehkun etta pitkaaikaisen uudistumisen.',

  // Science Inside - Default
  'scienceInside.default.subtitle': 'Tiede PDRN:n takana - miten se muuttaa ihosi sisaltapaoin',
  'scienceInside.default.tagline': 'PDRN aktivoi ihon luonnollisen korjausmekanismin, edistaa solujen uudistumista ja syvakosteuttaa jo ensimmaisesta kaytosta alkaen.',

  // Default product FAQ
  'productContent.default.faq1.q': 'Mika on PDRN ja miten se toimii?',
  'productContent.default.faq1.a': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta. Se aktivoi ihon luonnollisen korjausmekanismin adenosiini A2A -reseptorin kautta ja edistaa solujen uudistumista, kollageenin tuotantoa ja syvakosteuttamista.',
  'productContent.default.faq2.q': 'Sopiiko tuote herkalle iholle?',
  'productContent.default.faq2.a': 'Kylla! Kaavamme on dermatologisesti testattu, elainkokeeton ja ilman parabeeneja, sulfaatteja ja ftalaatteja. Se on suunniteltu hellavaraiseksi kaikille ihotyypeille, mukaan lukien herkalle iholle.',
  'productContent.default.faq3.q': 'Kuinka kauan tuloksia pitaa odottaa?',
  'productContent.default.faq3.a': 'Useimmat kayttajat huomaavat parantuneen kosteuden ja nakyyvan hehkun jo ensimmaisesta kaytosta. Optimaalisiin tuloksiin ilmeviivoissa ja ihon tekstuurissa suositellaan johdonmukaista kayttoa 4-8 viikkoa.',

  // Science Inside - Masks
  'scienceInside.masks.subtitle': 'Miten kolme tehokasta ainesosaa toimivat yhdessa jokaisessa kangasnaamiossa',
  'scienceInside.masks.tagline': 'PDRN korjaa solutasolla. B12-vitamiini kirkastaa. Niasiiniamidi vahvistaa. 20 minuuttia - siina kaikki mita ihosi tarvitsee imeytyakseen kaiken.',
  'scienceInside.masks.card1.title': 'PDRN + B12-vitamiini - hehkupari',
  'scienceInside.masks.card1.subtitle': 'Solujen korjaus kohtaa nakyvan hehkun',
  'scienceInside.masks.card1.point1': 'PDRN aktivoi solujen uudistumisen kun B12-vitamiini antaa valittoman kirkastavan vaikutuksen',
  'scienceInside.masks.card1.point2': 'Yhdessa ne hoitavat sameutta juurisyista - ei vain pintapuolista hehkua',
  'scienceInside.masks.card1.point3': 'B12 on todistettu ihonhoitoaine, joka tasaa ihon savya ajan myota',
  'scienceInside.masks.card1.point4': 'Pari toimii synergisesti - PDRN uudistaa, B12 kirkastaa',
  'scienceInside.masks.card2.title': 'Niasiiniamidi - suojamuurin rakentaja',
  'scienceInside.masks.card2.subtitle': 'Vahvistaa, tasapainottaa, suojaa',
  'scienceInside.masks.card2.point1': 'Vahvistaa ihon suojamuuria kosteuden lukitsemiseksi ja aarsykkeiden estamiseksi',
  'scienceInside.masks.card2.point2': 'Pienentaa nakyvasti huokosia ja saatelee liiallista talin tuotantoa',
  'scienceInside.masks.card2.point3': 'Vahentaa punoitusta ja rauhoittaa tulehduksia - ihanteellinen herkalle iholle',
  'scienceInside.masks.card2.point4': 'Toimii kaikissa ihon kerroksissa parantaen tekstuuria, savya ja kestavyytta',
  'scienceInside.masks.card3.title': 'Naamioefekti - 20 minuutin syvaimeytyininen',
  'scienceInside.masks.card3.subtitle': 'Miksi kangasnaamio on parempi kuin tavallinen seerumi',
  'scienceInside.masks.card3.point1': 'Kangasnaamio luo suljetun ympariston, joka estaa haihtumisen',
  'scienceInside.masks.card3.point2': 'Aktiiviset ainesosat toimitetaan suurempina pitoisuuksina kuin paivittaisissa seerumeissa',
  'scienceInside.masks.card3.point3': 'Syvaimeytyininen - ainesosat tunkeutuvat syvemmalle pitkittyneen ihokontaktin ansiosta',
  'scienceInside.masks.card3.point4': 'Valittomat ja nakyyat tulokset: taytlaisempi, kosteampi ja hehkuvampi iho jo yhden kayton jalkeen',

  // Science Inside - Cream
  'scienceInside.cream.subtitle': 'Kolme edistynyttaa teknologiaa, jotka toimivat yolla ihoasi muuttaen',
  'scienceInside.cream.tagline': 'Kollageeni uudistaa rakenteen. Keramidit suojaavat muurin. Alykkaat kapselit toimittavat kaiken laapi yon - jotta heratat uudistuneeseen ja kiinteaan ihoon.',
  'scienceInside.cream.card1.title': 'Hydrolysoitu kollageeni - rakenne',
  'scienceInside.cream.card1.subtitle': 'Uudistaminen sisaltapaoin',
  'scienceInside.cream.card1.point1': 'Pilkottu pieniksi palasiksi, jotka voivat oikeasti tunkeutua ihoon - ei vain istua pinnalla',
  'scienceInside.cream.card1.point2': 'Tukee ihon rakenteellista matriisia parantuneen kiinteyden ja joustavuuden saavuttamiseksi',
  'scienceInside.cream.card1.point3': 'Auttaa vahentamaan hienojen linjojen ulkonakoa tayttamalla sisaltapaoin',
  'scienceInside.cream.card1.point4': 'Toimii ihosi luonnollisen kollageenin tuotannon kanssa - vahvistaminen, ei korvaaminen',
  'scienceInside.cream.card2.title': 'Keramidikompleksi - suoja',
  'scienceInside.cream.card2.subtitle': 'Ihosi luonnollinen suoja, vahvistettuna',
  'scienceInside.cream.card2.point1': 'Keramidit muodostavat 50% ihon luonnollisesta suojamuurista - taydennamme sen mika on menetetty ian myota',
  'scienceInside.cream.card2.point2': 'Lukitsee kosteuden jopa 72 tunniksi - ei enaa kuivuuden ja kireyden tunnetta yolla',
  'scienceInside.cream.card2.point3': 'Suojaa ymparistovaurioilta: saasteet, kuiva ilma, lampotilanvaihtelut',
  'scienceInside.cream.card2.point4': 'Vahvistaa suojamuuria, jotta muut aktiiviset ainesosat toimivat tehokkaammin',
  'scienceInside.cream.card3.title': 'Alykaskapseliteknologia - asteittainen vapautuminen',
  'scienceInside.cream.card3.subtitle': 'Aktiiviset ainesosat toimitetaan koko yon',
  'scienceInside.cream.card3.point1': 'Mikrokapselit hajoavat asteittain ja vapauttavat aktiivisia ainesosia 8 tunnin ajan',
  'scienceInside.cream.card3.point2': 'Estaa ainesosien hajoamisen - ne pysyvat tehokkaina vapautumishetkeensa asti',
  'scienceInside.cream.card3.point3': 'Ihosi saa tasaisen virran ravintoa yhden suuren, haipuvan annoksen sijaan',
  'scienceInside.cream.card3.point4': 'Heraa uudistuneeseen ja kostutettuun ihoon - kapselit tekivat tyonsa nukkuessasi',

  // Science Inside - Bundle
  'scienceInside.bundle.subtitle': 'Miksi kolme tuotetta yhdessa antavat tuloksia, joita mikaan yksittainen tuote ei voi',
  'scienceInside.bundle.tagline': 'Naamiot puhdistavat ja ravitsevat. Seerumi korjaa ja kirkastaa. Voide lukitsee kaiken sisaan. Kolme vaihetta, yksi jarjestelma - 24 tuntia jatkuvaa ihon muutosta.',
  'scienceInside.bundle.card1.title': 'Kolme vaihetta, yksi jarjestelma',
  'scienceInside.bundle.card1.subtitle': 'Jokainen tuote valmistelee ihon seuraavaan vaiheeseen',
  'scienceInside.bundle.card1.point1': 'Vaihe 1: Kangasnaamiot puhdistavat syvaalle ja ravitsevat konsentroidulla PDRN:lla + B12-vitamiinilla',
  'scienceInside.bundle.card1.point2': 'Vaihe 2: Seerumi korjaa, kiinteytta ja antaa Glass Skin -efektin',
  'scienceInside.bundle.card1.point3': 'Vaihe 3: Voide lukitsee kaiken kollageenilla, keramideilla ja asteittain vapautuvilla kapseleilla',
  'scienceInside.bundle.card1.point4': 'Yhdessa: taysi rutiini, jossa jokainen vaihe tehostaa edellistaa',
  'scienceInside.bundle.card2.title': 'Synergiaefekti - parempi yhdessa',
  'scienceInside.bundle.card2.subtitle': 'Kumulatiiviset tulokset, jotka vahvistuvat ajan myota',
  'scienceInside.bundle.card2.point1': 'Kaikkien kolmen tuotteen kaytto luo kumulatiivisen efektin - tulokset rakentuvat toistensa paaalle',
  'scienceInside.bundle.card2.point2': 'PDRN jokaisessa vaiheessa tarkoittaa johdonmukaista solujen uudistumista laapi koko rutiinin',
  'scienceInside.bundle.card2.point3': 'Eri annostelutavat (naamio, seerumi, voide) varmistavat, etta ainesosat tavoittavat kaikki ihon kerrokset',
  'scienceInside.bundle.card2.point4': 'Asiakkaat raportoivat merkittavasti nopeampia tuloksia taydellisella rutiinilla',
  'scienceInside.bundle.card3.title': '24 tunnin kattavuus - paiva ja yo',
  'scienceInside.bundle.card3.subtitle': 'Ihosi ei ole koskaan suojaamaton',
  'scienceInside.bundle.card3.point1': 'Aamu: Seerumi meikin alle kosteuttamaan, suojaamaan ja hehkuttamaan koko paivan',
  'scienceInside.bundle.card3.point2': 'Ilta: Kangasnaamio syvapuhdistukseen ja ravitsemiseen (2-3 kertaa viikossa)',
  'scienceInside.bundle.card3.point3': 'Yo: Voide asteittain vapautuvilla kapseleilla, jotka toimivat nukkuessasi',
  'scienceInside.bundle.card3.point4': 'Tulos: Ymparivuorokautinen uudistuminen - ihosi paranee 24/7',

  // What is PDRN
  'whatIsPDRN.title': 'Mika on PDRN?',
  'whatIsPDRN.subtitle': 'Vallankumouksellinen ainesosa, joka muuttaa ihonhoidon maailmaa - klinikalta kotiisi',
  'whatIsPDRN.origin.title': 'Peraoisin lohen DNA:sta',
  'whatIsPDRN.origin.subtitle': 'Todistettu ainesosa esteettisessa laaketiedessa',
  'whatIsPDRN.origin.point1': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla ympaari maailmaa',
  'whatIsPDRN.origin.point1.US': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Yhdysvalloissa',
  'whatIsPDRN.origin.point1.GB': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Iso-Britanniassa',
  'whatIsPDRN.origin.point1.AU': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Australiassa',
  'whatIsPDRN.origin.point1.IL': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Israelissa',
  'whatIsPDRN.origin.point1.FI': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Suomessa',
  'whatIsPDRN.origin.point1.FR': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Ranskassa',
  'whatIsPDRN.origin.point1.DE': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Saksassa',
  'whatIsPDRN.origin.point1.ES': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Espanjassa',
  'whatIsPDRN.origin.point1.NO': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Norjassa',
  'whatIsPDRN.origin.point1.HR': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Kroatiassa',
  'whatIsPDRN.origin.point1.AE': 'PDRN (polideoksiribonukleotidi) on peraoisin lohen DNA:sta - bioyhteensopiva molekyyli, jota kaytetaan ihotautiklinikoilla kaikkialla Arabiemiirikunnissa',
  'whatIsPDRN.origin.point2': 'Tuettu kliinisilla tutkimuksilla mitattavilla tuloksilla kosteudessa ja joustavuudessa',
  'whatIsPDRN.origin.point3': 'Luonnollinen regeneratiivinen yhdiste - ei synteettisia taytteita, ei aggressiivisia kemikaaleja',
  'whatIsPDRN.howItWorks.title': 'Uudistuminen solutasolla',
  'whatIsPDRN.howItWorks.subtitle': 'Toimii siella, minne muut tuotteet eivat yllaa',
  'whatIsPDRN.howItWorks.point1': 'Aktivoi adenosiini A2A -reseptorin - kaynnistaa ihosi luonnollisen korjaus- ja uudistumisprosessin',
  'whatIsPDRN.howItWorks.point2': 'Edistaa kollageenin ja elastiinin tuotantoa sisaltapaoin, ei vain pintakosteutta',
  'whatIsPDRN.howItWorks.point3': 'Vahentaa tulehduksia ja rauhoittaa stressaantunutta ihoa terveemmaksi ja tasapainoisemmaksi ihoksi',
  'whatIsPDRN.results.title': 'Kliinikkatason tulokset kotona',
  'whatIsPDRN.results.subtitle': 'Viime aikoihin asti - vain klinikoilla',
  'whatIsPDRN.results.point1': 'Viime aikoihin asti PDRN-hoidot olivat saatavilla vain luksusihotautiklinikoilla korkeaan hintaan',
  'whatIsPDRN.results.point2': 'Kaavamme toimittavat saman aktiivisen ainesosan paivittaisessa muodossa, jonka voit levittaa kotona',
  'whatIsPDRN.results.point3': '+100% kosteuden parannus kliinisesti mitattu - nakyva parannus jo ensimmaisesta levityksesta',

  // Proven Results
  'provenResults.title': 'Todistetut tulokset',
  'provenResults.stat1.value': '+100%',
  'provenResults.stat1.label': 'Kosteuden parannus',
  'provenResults.stat1.sub': 'Kliinisesti mitattu',
  'provenResults.stat2.value': '93%',
  'provenResults.stat2.label': 'Sileampi iho',
  'provenResults.stat2.sub': 'Raportoitu 4 viikon sisalla',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Asiakasarvio',
  'provenResults.stat3.sub': 'Kaikkien tuotteiden keskiarvo',
  'provenResults.stat4.value': '+10 000',
  'provenResults.stat4.label': 'Tyytyvaisia asiakkaita',
  'provenResults.stat4.sub': 'Ympaari maailmaa',
  'provenResults.stat4.sub.US': 'Kaikkialla Yhdysvalloissa',
  'provenResults.stat4.sub.GB': 'Kaikkialla Iso-Britanniassa',
  'provenResults.stat4.sub.AU': 'Kaikkialla Australiassa',
  'provenResults.stat4.sub.IL': 'Kaikkialla Israelissa',
  'provenResults.stat4.sub.FI': 'Kaikkialla Suomessa',
  'provenResults.stat4.sub.FR': 'Kaikkialla Ranskassa',
  'provenResults.stat4.sub.DE': 'Kaikkialla Saksassa',
  'provenResults.stat4.sub.ES': 'Kaikkialla Espanjassa',
  'provenResults.stat4.sub.NO': 'Kaikkialla Norjassa',
  'provenResults.stat4.sub.HR': 'Kaikkialla Kroatiassa',
  'provenResults.stat4.sub.AE': 'Kaikkialla Arabiemiirikunnissa',

  // Comparison Table
  'comparison.title': 'PDRN verrattuna tavalliseen ihonhoitoon',
  'comparison.headerRegular': 'Tavallinen ihonhoito',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Vaikutustapa',
  'comparison.row1.regular': 'Pintakosteutus',
  'comparison.row1.pdrn': 'Uudistuminen solutasolla',
  'comparison.row2.criteria': 'Aktiivinen ainesosa',
  'comparison.row2.regular': 'Yleiset peptidit',
  'comparison.row2.pdrn': 'PDRN (lohen DNA)',
  'comparison.row3.criteria': 'Tulokset',
  'comparison.row3.regular': 'Viikkojen odotus tuloksiin',
  'comparison.row3.pdrn': 'Nakyvia jo ensimmaisesta kaytosta',
  'comparison.row4.criteria': 'Teknologia',
  'comparison.row4.regular': 'Vakiokaavat',
  'comparison.row4.pdrn': 'Kliinikkatason teknologia',
  'comparison.row5.criteria': 'Kliininen naytto',
  'comparison.row5.regular': 'Markkinointivaitteet',
  'comparison.row5.pdrn': 'Kliinisesti testattu +100% kosteutus',

  // FAQ
  'faq.sectionTitle': 'Usein kysytyt kysymykset',

  // 404
  '404.title': 'Sivua ei loydy',
  '404.subtitle': 'Etsimasi sivu ei ole olemassa tai se on siirretty.',
  '404.backHome': 'Takaisin etusivulle',
  '404.popularProducts': 'Suositut tuotteet',

  // Product disclaimer and extras
  'product.disclaimer': '*Kuvat ovat vain havainnollistavia. Tulokset voivat vaihdella henkilosta riippuen ihotyypin ja kayton mukaan. Tuote ei ole tarkoitettu sairauksien diagnosointiin, hoitoon tai ehkaisyyn. Suosittelemme herkkyystestin tekemista pienelle alueelle ennen ensimmaista taytta kayttoa. Jos herkistyimista ilmenee, lopeta kaytto. Vakavan herkistymisen yhteydessa ota yhteys laakaariin. Toimittaja voi aika ajoin muuttaa tuotteen pakkausta ja muotoa; kyseessa on sama tuote.',
  'product.shippingMarquee': 'Ilmainen toimitus tilauksiin yli {amount} Suomessa',
  'product.inStockReady': 'Varastossa - valmis toimitettavaksi',

  // Terms agreement
  'product.termsAgreementBefore': 'Selaamalla ja ostamalla talta sivustolta hyvaksytte',
  'product.termsLink': 'Kayttoehdot',
  'product.termsAgreementAfter': 'sivuston',

  // Announcement
  'announcement.freeShipping': '\u2728 ilmainen toimitus tilauksiin yli {amount} Suomessa',
  'announcement.close': 'Sulje',

  // Urgency
  'urgency.limitedOffer': 'Rajoitettu tarjous',
  'urgency.endsIn': 'Paattyy',

  // Blog
  'blog.title': 'Blogi',
  'blog.subtitle': 'Ammattimaiset ihonhoito-oppaat, PDRN-tiede ja vinkit korealaisesta ihonhoidosta',
  'blog.metaDescription': 'Lue ammattimaiset oppaamme PDRN-ihonhoidosta, lohen DNA -tieteesta, Glass Skin -rutiineista ja korealaisista ihonhoitovinkeista.',
  'blog.readMore': 'Lue lisaa',
  'blog.minRead': 'min lukemista',
  'blog.badge': 'Tieteellisesti todistettu ihonhoito',
  'blog.chip.antiAging': 'Anti-aging',
  'blog.chip.hydration': 'Kosteus',
  'blog.chip.sensitiveSkin': 'Herkkä iho',
  'blog.chip.nightRoutine': 'Iltarutiini',
  'blog.chip.ingredients': 'Ainesosat',
  'blog.chip.layering': 'Kerrostus',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'PDRN-tiede',
  'blog.relatedArticles': 'Aiheeseen liittyvat artikkelit',
  'blog.recommendedProducts': 'Suositellut tuotteet',
  'blog.latestArticles': 'Uusimmat blogissamme',
  'blog.latestSubtitle': 'Ammattimaiset PDRN-ihonhoito-oppaat ja vinkit korealaisesta ihonhoidosta',
  'blog.viewAll': 'Kaikki artikkelit',
  'blog.statsArticles': 'Artikkelia',
  'blog.statsLanguages': 'Kieltä',
  'blog.statsVersions': 'Käännettyä versiota',
  'blog.availableIn': 'Saatavilla 11 kielellä',
  'blog.avgReadTime': 'Keskim. 5 min lukuaika',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Ihonhoito | Korealainen Lohi-DNA Seerumi, Naamiot & Voide | Glass Skin',
  'seo.homeDescription': 'PDRN-ihonhoito korealaisella lohi-DNA-teknologialla. PDRN-seerumi, kangasnaamiot ja kapselivoide Glass Skin -efektiin. Kliinisesti testattu ja ilmainen toimitus.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'PDRN Seerumi Lohi-DNA:lla & Peptideillä | PDRN Ihonhoito',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'Osta PDRN-seerumi lohi-DNA:lla ja peptideillä. Korealainen Glass Skin -seerumi joka tehostaa kollageenia ja silottaa ryppyjä. PDRN-ihonhoito ilmaisella toimituksella.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'PDRN Kangasnaamiot 10 kpl | Korealaiset Lohi-DNA Naamiot | PDRN Ihonhoito',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'Osta PDRN-kangasnaamiot kyllästettyinä lohi-DNA-seerumilla. 10 korealaista kasvonaamiota Glass Skin -efektiin PDRN:llä, B12-vitamiinilla ja niasiiniamidilla.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'PDRN Kapselivoide Kollageenilla | Korealainen Ihonhoito | PDRN Ihonhoito',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'Osta PDRN-kapselivoide kollageenilla ja niasiiniamidilla. Korealainen anti-aging-voide lohi-DNA-teknologialla syväkosteuttamiseen ja kiinteytykseen.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Täydellinen PDRN Ihonhoitosetti — Seerumi, Naamiot & Voide | PDRN Ihonhoito',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Osta täydellinen PDRN-ihonhoitosetti seerumilla, 10 naamiolla ja voiteella. Säästä jopa 53% korealaisessa lohi-DNA-ihonhoidossa.',

  // Internal linking
  'seo.explorePDRN': 'Tutustu PDRN-ihonhoitoon',
  'seo.anchor.serumBenefits': 'PDRN-seerumin hyödyt',
  'seo.anchor.howPDRNWorks': 'Miten PDRN toimii',
  'seo.anchor.masksVsTraditional': 'PDRN-naamiot vs. perinteiset',
  'seo.anchor.glassSkinGuide': 'Glass Skin -opas',
  'seo.anchor.koreanSecret': 'Korealainen ihonhoitosalaisuus',
  'seo.anchor.pdrnVsRegular': 'PDRN vs. tavallinen ihonhoito',
};
